import React from "react";

export const GRID_CLICK_SUPPRESSED_SELECTOR =
  "[data-grid-click-suppressed='true']";

export const stopGridClickPropagation = (
  event: React.SyntheticEvent<HTMLElement>,
) => {
  event.preventDefault();
  event.stopPropagation();
};

/** Stops row navigation without preventDefault, so nested controls can take focus. */
export const stopGridClickBubble = (
  event: React.SyntheticEvent<HTMLElement>,
) => {
  event.stopPropagation();
};

/**
 * Marks a subtree as a grid click boundary.
 * Click still preventDefault+stopPropagation; pointer/mousedown only bubble-stop
 * so buttons inside remain focusable.
 */
export const getGridClickBoundaryProps = () =>
  ({
    "data-grid-click-suppressed": "true",
    onClick: stopGridClickPropagation,
    onMouseDown: stopGridClickBubble,
    onPointerDown: stopGridClickBubble,
  }) as const;
